<template>
  <v-dialog v-model="dialog" max-width="520">
    <v-card>
      <v-card-title>Формирование отчёта</v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-select
            v-model="selectedType"
            :items="reportTypes"
            item-title="title"
            item-value="code"
            label="Тип отчёта"
            :rules="[requiredRule]"
            :loading="typesLoading"
            return-object
          />

          <v-date-input
            v-model="from"
            label="Период с"
            class="mt-3"
            clearable
            :menu-props="{ contentClass: 'responsive-menu' }"
          />

          <v-date-input
            v-model="to"
            label="По состоянию на"
            class="mt-3"
            clearable
            :menu-props="{ contentClass: 'responsive-menu' }"
          />

          <v-alert
            v-if="errorMessage"
            type="error"
            density="compact"
            class="mt-4"
          >
            {{ errorMessage }}
          </v-alert>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn variant="text" @click="closeModal">
          Отмена
        </v-btn>

        <v-btn
          color="primary"
          :loading="fileLoading"
          @click="createReport"
        >
          Сформировать
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import plicanteRequestService from '@/services/plicante.request.service';
import { VDateInput } from 'vuetify/labs/VDateInput'

export default {
  name: 'SummaryReportModal',

  components: {
    VDateInput
  },

  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },

  emits: ['update:modelValue'],

  data() {
    return {
      valid: false,

      reportTypes: [],
      selectedType: null,

      from: null,
      to: null,

      typesLoading: false,
      fileLoading: false,

      errorMessage: ''
    }
  },

  computed: {
    dialog: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },

  watch: {
    dialog: {
      immediate: true,
      async handler(value) {
        if (value) {
          this.errorMessage = ''
          await this.loadReportTypes()
        }
      }
    }
  },

  methods: {
    requiredRule(value) {
      return !!value || 'Поле обязательно'
    },

    async loadReportTypes() {
      this.typesLoading = true

      const url = `${process.env.VUE_APP_BASE_URL}/api/v1/cropProduction/summaryReport/types`

      try {
        const response = await plicanteRequestService.get(url)
        this.reportTypes = response?.data || []
      } catch (error) {
        this.errorMessage = this.getErrorMessage(error)
      } finally {
        this.typesLoading = false
      }
    },

    async createReport() {
      this.errorMessage = ''

      const validation = await this.$refs.form.validate()
      if (!validation.valid) return

      this.fileLoading = true

      const url = `${process.env.VUE_APP_BASE_URL}/api/v1/cropProduction/summaryReport/createExcel`

      const payload = {
        type: this.selectedType.code,
        isDetailed: true,
        from: this.from ? this.formatDate(this.from) : null,
        to: this.to ? this.formatDate(this.to) : null,
        onlyOwnDistrict: true
      }

      try {
        const response = await plicanteRequestService.post(url, payload, {
          responseType: 'blob'
        })

        this.downloadFile(response.data)
        this.closeModal()
      } catch (error) {
        this.errorMessage = this.getErrorMessage(error)
      } finally {
        this.fileLoading = false
      }
    },

    formatDate(value) {
      if (!value) return null

      const date = new Date(value)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },

    downloadFile(fileData) {
      const blob = fileData instanceof Blob
        ? fileData
        : new Blob([fileData], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

      const fileDate = this.to ? this.formatDate(this.to) : this.getToday()
      const fileName = `${this.selectedType.title} ${fileDate}.xlsx`

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = url
      link.download = fileName

      document.body.appendChild(link)
      link.click()
      link.remove()

      window.URL.revokeObjectURL(url)
    },

    closeModal() {
      this.dialog = false
    },

    getToday() {
      return this.formatDate(new Date())
    },

    getErrorMessage(error) {
      return (
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.data?.message ||
        error?.message ||
        'Произошла ошибка'
      )
    }
  }
}
</script>
